<div #topOfPage></div>
<div class="container">
    <div class="page-title">
        <div class="row">
            <div class="sorteo-column2">
                <h1>SORTEOS</h1>
                <span>{{info.title}}</span>
                <p>{{info.description}}</p>
            </div>
            <div class="sorteo-column3">
                <form (submit)="onSubmit()" [class.submitted]="submitted">
                    <mat-form-field>
                        <mat-label>Tipo de sorteo</mat-label>
                            <mat-select [(value)]="selected" (selectionChange)="onSelectionChange()">
                            <mat-option value="insta">Insta</mat-option>
                            <mat-option [disabled]="true" value="twitch">Twitch</mat-option>
                            <mat-option [disabled]="true" value="gofund">GoFund</mat-option>
                            <mat-option value="total">Total</mat-option>
                            <mat-option value="Coolligan">Coolligan</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button *ngIf="selected!='Coolligan'" mat-flat-button type="submit" color="primary">SORTEAR</button>
                </form>
            </div>
        </div>
    </div>
    <mat-divider></mat-divider>

    <div class="center">
        <h4>El ganador es...</h4>
        <div class="center" *ngIf="ganador != undefined">
            <img class="winner-img" src="{{getImageUrl(ganador.platform)}}">
            <h2 class="winner-title">{{ganador.name}}</h2>
        </div>
        <mat-spinner [diameter]="30" *ngIf="submitted"></mat-spinner> 
        <div class="suplente" *ngIf="suplente != undefined">
            <img src="{{getImageUrl(suplente.platform)}}">
            <p>Suplente: {{suplente.name}}</p>
        </div>
    </div>

    <div class="accordion" *ngIf="selected!='Coolligan'">
        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                    Participantes
                    </mat-panel-title>
                    <mat-panel-description>
                    {{info.restrictions}}
                    </mat-panel-description>
                </mat-expansion-panel-header>
    
                <div class="responsive_table">
                    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)">
                    <!-- Platform Column -->
                    <ng-container matColumnDef="platform">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by platform">
                        Platform
                        </th>
                        <td mat-cell *matCellDef="let element"> <img src="{{getImageUrl(element.platform)}}"> </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name">
                        Nombre
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="part">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by part">
                        Participaciones
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.part}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons aria-label="Select page"></mat-paginator>    
                </div>
    
            </mat-expansion-panel>
        </mat-accordion>
    </div>
    <div *ngIf="selected=='Coolligan'">
        <div *ngFor="let p of participantes" class="quote-card" (click)="elegirGanador(p)">
            <div class="columna">
                <img src="{{getImageUrl(p.platform)}}">
                <div class="profile-pic">
                  <img [src]="p.imgUrl" alt="{{p.user}}">
                </div>
            </div>
            <div class="quote-content">
              <div class="name">{{p.user}}</div>
              <div class="text">{{p.message}}</div>
            </div>
        </div>
    </div>
</div>